export const CHANGE_QUESTIONLIST = 'question/change_question_list'
